<div @fade class="mail-preview-container" #previewContainer [ngClass]="{ 'mail-preview-popup-state': size === 'popup' }">
  <div class="mail-preview-content">
    <mail-preview-header
      #previewHeaderContainer
      [viewModel]="viewModel"
      [model]="model"
      [telemetrySearch]="telemetrySearch"
      [componentFocused]="childComponentFocused"
      (componentFocusedExit)="onComponentFocusedExit($event)"
    ></mail-preview-header>
    <div class="mail-preview-loading" *ngIf="!startLoadBody; else loading" [style.height.px]="contentHeight">
      <preview-error *ngIf="error; else bodyContainer" (again)="load()"></preview-error>
      <ng-template #bodyContainer>
        <preview-not-available *ngIf="!body"></preview-not-available>
        <ng-scrollbar *ngIf="body" visibility="hover" #contentBody class="mail-preview-body" [style.maxHeight.px]="contentHeight">
          <div #previewContent class="body" data-cy="mail-preview-content" [innerHtml]="body"></div>
        </ng-scrollbar>
      </ng-template>
    </div>
  </div>
  <mail-preview-attachment
    #previewAttachmentContainer
    [dragMetadata]="viewModel?.dragMetadata"
    [attachments]="viewModel?.attachments"
    [componentFocused]="childComponentFocused"
    (componentFocusedExit)="onComponentFocusedExit($event)"
  ></mail-preview-attachment>
</div>

<ng-template #loading>
  <loader-overlay [style.height.px]="contentHeight"> </loader-overlay>
</ng-template>
